module.exports = __webpack_public_path__ + "static/media/9.53a56341.jpg";